export default __webpack_public_path__ + "static/media/grid.6656b352.svg";